import { FC, PropsWithChildren, useEffect } from 'react';

import { CookieAuthInitProvider, OrganizationManager } from '@gasbi/shared';

import { useLazyGetCurrentUserQuery } from '@/features/auth/authApi';
import { AppAuthProvider } from '@/providers/AppAuthProvider';
import http from '@/utils/http';

export const AuthInitProvider: FC<PropsWithChildren> = ({ children }) => {
  // Cookie session (GSB-8274, PO 2026-10-25): one GET of the organization the session remembers, next to the user.
  // The redirect into an organization opens it (`useSessionOrganization`); the pages mount only once the user is
  // loaded, so they find this call started. Without the endpoint (404) the redirect picks the organization as before;
  // a user without an organization (403) is sent to the not-authorized page there, so the rejection is read there.
  useEffect(() => {
    OrganizationManager.initialize({ http }).catch(() => undefined);
  }, []);

  return (
    <CookieAuthInitProvider
      useLazyGetCurrentUserQuery={useLazyGetCurrentUserQuery}
      AppAuthProvider={AppAuthProvider}
    >
      {children}
    </CookieAuthInitProvider>
  );
};
